import { render } from "./AddCategorieClientModal.vue?vue&type=template&id=98e247e6&ts=true"
import script from "./AddCategorieClientModal.vue?vue&type=script&lang=ts"
export * from "./AddCategorieClientModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__